import React from 'react';
import ExerciseLayout from './ExerciseLayout';
import ExerciseCard from './ExerciseCard';

const ExerciseResults = ({
  title = 'Výsledky',
  score,
  total,
  color = 'blue',
  onRestart,
  onBack,
  children,
  diarySection
}) => {
  const percentage = Math.round((score / total) * 100);
  const isSuccess = percentage >= 50;

  const colorClasses = {
    purple: {
      progressStroke: '#a855f7',
      successBg: 'bg-purple-50',
      successText: 'text-purple-600',
      buttonPrimary: 'bg-purple-500 hover:bg-purple-600',
      buttonSecondary: 'border-purple-500 text-purple-500 hover:bg-purple-50'
    },
    amber: {
      progressStroke: '#f59e0b',
      successBg: 'bg-amber-50',
      successText: 'text-amber-600',
      buttonPrimary: 'bg-amber-500 hover:bg-amber-600',
      buttonSecondary: 'border-amber-500 text-amber-500 hover:bg-amber-50'
    },
    blue: {
      progressStroke: '#3b82f6',
      successBg: 'bg-blue-50',
      successText: 'text-blue-600',
      buttonPrimary: 'bg-blue-500 hover:bg-blue-600',
      buttonSecondary: 'border-blue-500 text-blue-500 hover:bg-blue-50'
    },
    rose: {
      progressStroke: '#f43f5e',
      successBg: 'bg-rose-50',
      successText: 'text-rose-600',
      buttonPrimary: 'bg-rose-500 hover:bg-rose-600',
      buttonSecondary: 'border-rose-500 text-rose-500 hover:bg-rose-50'
    }
  };

  const colors = colorClasses[color] || colorClasses.blue;

  // Calculate circumference for progress circle
  const circumference = 2 * Math.PI * 45;

  return (
    <ExerciseLayout
      title={title}
      color={color}
      onBack={onBack}
    >
      <ExerciseCard className="mb-6">
        {/* Score display */}
        <div className="flex flex-col items-center py-6">
          {/* Circular progress */}
          <div className="relative w-32 h-32 mb-4">
            <svg className="w-32 h-32 transform -rotate-90">
              <circle
                cx="64"
                cy="64"
                r="45"
                stroke="#e5e7eb"
                strokeWidth="8"
                fill="none"
              />
              <circle
                cx="64"
                cy="64"
                r="45"
                stroke={isSuccess ? '#22c55e' : '#ef4444'}
                strokeWidth="8"
                fill="none"
                strokeDasharray={`${(percentage / 100) * circumference} ${circumference}`}
                strokeLinecap="round"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className={`text-3xl font-bold ${isSuccess ? 'text-green-600' : 'text-red-500'}`}>
                {percentage}%
              </span>
            </div>
          </div>

          {/* Score text */}
          <div className="text-center">
            <p className="text-2xl font-bold text-gray-800 mb-1">
              {score} / {total}
            </p>
            <p className={`text-lg font-medium ${isSuccess ? 'text-green-600' : 'text-red-500'}`}>
              {isSuccess ? 'Uspesne dokonceno!' : 'Zkuste to znovu'}
            </p>
          </div>

          {/* Success/Failure icon */}
          <div className={`mt-4 w-16 h-16 rounded-full flex items-center justify-center ${isSuccess ? 'bg-green-100' : 'bg-red-100'}`}>
            {isSuccess ? (
              <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </div>
        </div>
      </ExerciseCard>

      {/* Custom details section */}
      {children && (
        <ExerciseCard className="mb-6">
          {children}
        </ExerciseCard>
      )}

      {diarySection && (
        <div className="mb-4">
          {diarySection}
        </div>
      )}

      {/* Action buttons */}
      <div className="flex gap-4 justify-center">
        <button
          onClick={onRestart}
          className={`px-6 py-3 rounded-lg font-medium border-2 transition-colors ${colors.buttonSecondary}`}
        >
          Zkusit znovu
        </button>
        <button
          onClick={onBack}
          className={`px-6 py-3 rounded-lg font-medium text-white transition-colors ${colors.buttonPrimary}`}
        >
          Zpět na menu
        </button>
      </div>
    </ExerciseLayout>
  );
};

export default ExerciseResults;
